// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"31cb053d","239":"fac1b50d","453":"497535a4","729":"1e6f40a7","732":"0e87da3a"}[chunkId] + ".chunk.js";
};